import React from 'react';
import TaskSlide from '../../../../general/TaskSlide';
import { ISlide } from '../../../../core/Slide';
import { t } from 'ttag';

const DebugGameIntro: React.FC<ISlide> = ({ nextSlide, defaultHeader }) => {
    return (
        <TaskSlide onStart={nextSlide} header={defaultHeader} number={4}>
            {t`Help Amber spot the mistakes in the athletes kit.`}
        </TaskSlide>
    );
};

export default DebugGameIntro;
